// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--6-2!../../../node_modules/postcss-loader/lib/index.js??ref--6-3!./vueperslides.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("6ddf0181", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/vueperslides.min.css
// module id = KTjF
// module chunks = 0 80 81 82